<sk-sidebar
  title="Nick Fury"
  [badge]="badge()"
  [items]="sidebarItems()"
  [userProfile]="userProfile()"
  [userMenuItems]="userMenuItems()"
  [(collapsed)]="collapsed"
  [expandedWidth]="256"
  [collapsedWidth]="80"
  [mode]="mode()"
  [density]="density()"
  (actionClick)="onActionClick($event)"
  (userProfileClick)="onUserProfileClick()"
  (userMenuItemClick)="onUserMenuItemClick($event)"
>
  <img sidebar-logo src="favicon.png" alt="Fury" class="w-10 h-10" />

  <div sidebar-custom class="nf-sidebar-client-wrap">
    @if (!collapsed()) {
      <div class="nf-sidebar-client-label">{{ 'layout.sidebar.activeClient' | transloco }}</div>
      <!-- title: sk-select ellipsizes long client names at the larger text size -->
      <div class="nf-sidebar-client-select" data-sk-tour="sidebar-client" [attr.title]="selectedClient().label">
        <sk-select
          [options]="clientContext.clients()"
          [placeholder]="'layout.sidebar.selectClient' | transloco"
          [formControl]="clientControl"
          [searchable]="true"
          [loading]="clientContext.isLoading()"
          optionMediaSize="md"
        />
      </div>
      @if (clientContext.loadError(); as error) {
        <nf-error-state
          [compact]="true"
          [title]="'layout.sidebar.clientsLoadError' | transloco"
          [error]="error"
          [loading]="clientContext.isLoading()"
          (retry)="clientContext.retry()" />
      }
    } @else {
      <div class="nf-sidebar-client-logo" [attr.title]="selectedClient().label">
        @if (selectedClient().image) {
          <img [src]="selectedClient().image" [alt]="selectedClient().label" />
        } @else {
          <span>{{ selectedClient().label.charAt(0) }}</span>
        }
      </div>
    }
  </div>

  @if (sidebarLoading() && !collapsed()) {
    <div sidebar-extra class="nf-sidebar-skeleton" aria-hidden="true">
      <div class="nf-sidebar-skeleton-label"></div>
      <div class="nf-sidebar-skeleton-row"></div>
      <div class="nf-sidebar-skeleton-row"></div>
      <div class="nf-sidebar-skeleton-label"></div>
      <div class="nf-sidebar-skeleton-row"></div>
      <div class="nf-sidebar-skeleton-row"></div>
      <div class="nf-sidebar-skeleton-row"></div>
    </div>
  }

  @if (sidebarError(); as error) {
    @if (!collapsed()) {
      <div sidebar-extra>
        <nf-error-state
          [compact]="true"
          [title]="sidebarErrorTitle()"
          [error]="error"
          (retry)="retrySidebar()" />
      </div>
    }
  }

  @if (userRole() === 'admin') {
    <div sidebar-admin>
      <button
        type="button"
        data-sk-tour="sidebar-admin"
        class="sk-sb-item sk-sb-item--accent nf-sidebar-admin-btn"
        style="
          --sk-sb-item-accent-color: var(--sk-color-info-700);
          --sk-sb-item-accent-hover-bg: var(--sk-color-info-50);
        "
        (click)="onActionClick('admin')"
      >
        <span class="sk-sb-item-icon p-3">
          <sk-icon name="shield-plus" size="sm" />
        </span>
        @if (!collapsed()) {
          <span class="sk-sb-item-label p-1">{{ 'layout.sidebar.admin' | transloco }}</span>
        }
      </button>
    </div>
  }
</sk-sidebar>
